<script lang="ts">
import {defineComponent} from 'vue'

export default defineComponent({
    name: "IconCar1"
})
</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="17">
        <circle cx="29.4" cy="14.5" r="2.5"/>
        <circle cx="5.5" cy="14.5" r="2.5"/>
        <path
            d="M35.9 9c-.4-3-8-4-8-4s-1-1.6-3-3c-1.9-1.4-4-2-4-2H2S0 .4 0 2v10c0 .7 1 2 1 2h1s-.5-3 3-3c4.2 0 4 3 4 3h17s.2-3 3-3 4 3 4 3h3c-.1 0 .1-3.3-.1-5"/>
    </svg>
</template>

<style scoped lang="scss">

</style>
